import React, { useState } from 'react';
import './Ctc.css';
import { Table, Form, Button } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

const CTCBreakupCalculator = () => {
  const location = useLocation();

  const [ctc, setCtc] = useState(location.state?.item?.ctc || '');
  const [mi, setMi] = useState(location.state?.item?.medicalInsurance || '');
  const [payType, setPayType] = useState('none'); 
  const [vp, setVp] = useState(location.state?.item?.variablePay || '');
  const [dp, setDp] = useState(location.state?.item?.deferredPay || '');
  const [name, setName] = useState(location.state?.item?.name || '');
  const [desig, setDesig] = useState(location.state?.item?.designation || '');
  const [abasic, setaBasic] = useState(0);
  const [mbasic, setmBasic] = useState(0);
  const [ahra, setaHra] = useState(0);
  const [mhra, setmHra] = useState(0);
  const [ada, setaDa] = useState(0);
  const [mda, setmDa] = useState(0);
  const [acon, setaCon] = useState(0);
  const [mcon, setmCon] = useState(0);
  const [ama, setaMa] = useState(0);
  const [mma, setmMa] = useState(0);
  const [aspecialAllowance, setaSpecialAllowance] = useState(0);
  const [mspecialAllowance, setmSpecialAllowance] = useState(0);
  const [aepf, setaEpf] = useState(0);
  const [mepf, setmEpf] = useState(0);
  const [ast, setaSt] = useState(0);
  const [mst, setmSt] = useState(0);
  const [asubto, setaSubto] = useState(0);
  const [ags, setaGs] = useState(0);
  const [gratuity, setGratuity] = useState(0);
  const [calculationDone, setCalculationDone] = useState(false);

  const [nameError, setNameError] = useState('');
  const [desigError, setDesigError] = useState('');
  const [ctcError, setCtcError] = useState('');
  const [miError, setMiError] = useState('');
  const [vpError, setVpError] = useState('');
  const [dpError, setDpError] = useState('');

  const navigate = useNavigate();

  const item = location.state?.item;

  const handleNameChange = (e) => {
    setName(e.target.value);
    setNameError(e.target.value.length < 2 ? 'Enter a valid Name' : '');
  };

  const handleDesigChange = (e) => {
    setDesig(e.target.value);
    setDesigError(e.target.value.length < 2 ? 'Enter a valid Designation' : '');
  };

  const handleCtcChange = (e) => {
    setCtc(e.target.value);
    setCtcError(e.target.value < 1 ? 'Enter a valid CTC' : '');
  };

  const handleMiChange = (e) => {
    setMi(e.target.value);
    setMiError(e.target.value < 1 ? 'Enter a valid Medical Insurance' : '');
  };

  const handleVpChange = (e) => {
    setVp(e.target.value);
    setVpError(e.target.value <= 0 && payType === 'variable' ? 'Enter a valid Variable Pay' : '');
  };

  const handleDpChange = (e) => {
    setDp(e.target.value);
    setDpError(e.target.value <= 0 && payType === 'deferred' ? 'Enter a valid Deferred Pay' : '');
  };

  const isFormValid = () => {
    if (
      !name ||
      !desig ||
      !ctc ||
      !mi ||
      (payType === 'variable' && !vp) ||
      (payType === 'deferred' && !dp)
    ) {
      return false;
    }

    if (nameError || desigError || ctcError || miError) {
      return false;
    }
    if (payType === 'variable' && vp <= 0) {
      return false;
    }
    if (payType === 'deferred' && dp <= 0) {
      return false;
    }
    return true;
  };

  const calculateBreakup = () => {
    if (!isFormValid()) {
      return;
    }

    const ctcValue = parseFloat(ctc);
    const miValue = parseFloat(mi);
    let vpValue = 0;
    let dpValue = 0;
    if (payType === 'variable') {
      vpValue = Math.round(parseFloat(vp) || 0);
    } else if (payType === 'deferred') {
      dpValue = Math.round(parseFloat(dp) || 0);
    }

    let calcaEpf;
    if (ctcValue > 353360) {
      calcaEpf = 21600;
    } else {
      calcaEpf = ctcValue * 0.0603821428571428;
    }
    setaEpf(calcaEpf);
    const calcmEpf = calcaEpf / 12;
    setmEpf(calcmEpf);

    const actualValue = (ctcValue - ((vpValue + dpValue) + miValue + calcaEpf + calcaEpf)) / 1.028845;

    const abasicSalary = actualValue * 0.5;
    setaBasic(abasicSalary);
    const mbasicSalary = (actualValue * 0.5) / 12;
    setmBasic(mbasicSalary);

    const ahraAmount = actualValue * 0.3;
    setaHra(ahraAmount);
    const mhraAmount = (actualValue * 0.3) / 12;
    setmHra(mhraAmount);

    const adaAmount = actualValue * 0.1;
    setaDa(adaAmount);
    const mdaAmount = (actualValue * 0.1) / 12;
    setmDa(mdaAmount);

    const aconAmount = actualValue * 0.04;
    setaCon(aconAmount);
    const mconAmount = (actualValue * 0.04) / 12;
    setmCon(mconAmount);

    const amaAmount = actualValue * 0.03;
    setaMa(amaAmount);
    const mmaAmount = (actualValue * 0.03) / 12;
    setmMa(mmaAmount);

    const asaAmount = actualValue * 0.03;
    setaSpecialAllowance(asaAmount);
    const msaAmount = (actualValue * 0.03) / 12;
    setmSpecialAllowance(msaAmount);

    const astAmount = abasicSalary + ahraAmount + adaAmount + aconAmount + amaAmount + asaAmount + calcaEpf;
    setaSt(astAmount);
    const mstAmount = mbasicSalary + mhraAmount + mdaAmount + mconAmount + mmaAmount + msaAmount + calcmEpf;
    setmSt(mstAmount);

    const graAmount = (mbasicSalary + mdaAmount) * 0.5769;
    setGratuity(graAmount);

    const asubtoAmount = calcaEpf + miValue + graAmount + vpValue + dpValue;
    setaSubto(asubtoAmount);

    const agsAmount = astAmount + asubtoAmount;
    setaGs(agsAmount);

    setCalculationDone(true);
  };

  const resetForm = () => {
    setName('');
    setDesig('');
    setCtc('');
    setMi('');
    setVp('');
    setDp('');
    setPayType('none');
    setCalculationDone(false);
  };

  const updateLocalStorage = (data) => {
    localStorage.setItem('ctcData', JSON.stringify(data));
  };

  const savectcBreakup = () => {
    const id = item?.id || uuidv4();
    const newCtc = {
      id: id,
      name: name,
      designation: desig,
      ctc: Math.round(parseFloat(ctc)),
      medicalInsurance: Math.round(parseFloat(mi) || 0),
      variablePay: Math.round(parseFloat(vp) || 0),
      deferredPay: Math.round(parseFloat(dp) || 0),
      annualBasicSalary: Math.round(abasic),
      annualHra: Math.round(ahra),
      annualDa: Math.round(ada),
      annualCon: Math.round(acon),
      annualMedicalAllowance: Math.round(ama),
      annualSpecialAllowance: Math.round(aspecialAllowance),
      annualGrossSalary1: Math.round(ast),
      annualGrossSalary2: Math.round(asubto),
      annualEpf: Math.round(aepf),
      gratuity: Math.round(gratuity),
      monthlyBasicSalary: Math.round(mbasic),
      monthlyHra: Math.round(mhra),
      monthlyDa: Math.round(mda),
      monthlyCon: Math.round(mcon),
      monthlyMedicalAllowance: Math.round(mma),
      monthlySpecialAllowance: Math.round(mspecialAllowance),
      monthlyEpf: Math.round(mepf),
      monthlyGrossSalary1: Math.round(mst),
    };

    const storedData = JSON.parse(localStorage.getItem('ctcData')) || [];
    let updatedData;

    if (item) {
      updatedData = storedData.map((data) => (data.id === id ? newCtc : data));
    } else {
      updatedData = [...storedData, newCtc];
    }

    updateLocalStorage(updatedData);
    navigate('/');
  };

  const formatter = new Intl.NumberFormat('en-IN', {
    currency: 'INR',
    maximumFractionDigits: 0,
  });

  return (
    <div className="ctc">
      <div className="ctc-content">
        <Button className="home-button" onClick={() => navigate('/')}>
          Home
        </Button>
        <h2 className="title">CTC Calculator</h2>
        <div className="form">
          <Form style={{ padding: '20px' }}>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label className="label">
                Enter Name:
                <input type="text" value={name} onChange={handleNameChange} style={{ marginLeft: '10px' }} />
                {nameError && <div className="error">{nameError}</div>}
              </Form.Label>
            </Form.Group>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label className="label">
                Enter Designation:
                <input type="text" value={desig} onChange={handleDesigChange} style={{ marginLeft: '10px' }} />
                {desigError && <div className="error">{desigError}</div>}
              </Form.Label>
            </Form.Group>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label className="label">
                Enter CTC:
                <input type="number" value={ctc} onChange={handleCtcChange} style={{ marginLeft: '10px' }} />
                {ctcError && <div className="error">{ctcError}</div>}
              </Form.Label>
            </Form.Group>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label className="label">
                Enter Medical Insurance:
                <input type="number" value={mi} onChange={handleMiChange} style={{ marginLeft: '10px' }} />
                {miError && <div className="error">{miError}</div>}
              </Form.Label>
            </Form.Group>
            <div className="pay-type">
              <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Label className="label">
                  Variable Pay:
                  <input
                    type="radio"
                    value="variable"
                    checked={payType === 'variable'}
                    onChange={(e) => {
                      setPayType(e.target.value);
                    }}
                  />
                </Form.Label>
              </Form.Group>
              <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Label className="label">
                  Deferred Pay:
                  <input
                    type="radio"
                    value="deferred"
                    checked={payType === 'deferred'}
                    onChange={(e) => {
                      setPayType(e.target.value);
                    }}
                  />
                </Form.Label>
              </Form.Group>
              <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Label className="label">
                  None:
                  <input
                    type="radio"
                    value="none"
                    checked={payType === 'none'}
                    onChange={(e) => {
                      setPayType(e.target.value);
                    }}
                  />
                </Form.Label>
              </Form.Group>
            </div>
          </Form>
          {payType === 'variable' && (
            <div className="pay-input">
              <label className="pay-label">
                Enter Variable Pay:
                <input type="number" style={{ marginLeft: '10px' }} value={vp} onChange={handleVpChange} />
                {vpError && <div className="error">{vpError}</div>}
              </label>
            </div>
          )}
          {payType === 'deferred' && (
            <div className="pay-input">
              <label className="pay-label">
                Enter Deferred Pay:
                <input type="number" style={{ marginLeft: '10px' }} value={dp} onChange={handleDpChange} />
                {dpError && <div className="error">{dpError}</div>}
              </label>
            </div>
          )}
        </div>

        <button className="cal-button" onClick={calculateBreakup} disabled={!isFormValid()}>
          <b>Calculate</b>
        </button>

        <button className="reset-button" onClick={resetForm} style={{ marginLeft: '10px' }}>
          <b>Reset</b>
        </button>
        <div>
          {calculationDone && (
            <div className="table ">
              <Table responsive striped bordered hover className="tab">
                <thead>
                  <tr>
                    <th>Components</th>
                    <th>Per Annum</th>
                    <th>Per Month</th>
                  </tr>
                </thead>
                <tbody className="tablebody">
                  <tr>
                    <td>BASIC</td>
                    <td>
                      <p>INR {formatter.format(abasic.toFixed(2))}</p>
                    </td>
                    <td>
                      <p>INR {formatter.format(mbasic.toFixed(2))}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>HRA</td>
                    <td>
                      <p>INR {formatter.format(ahra.toFixed(2))}</p>
                    </td>
                    <td>
                      <p>INR {formatter.format(mhra.toFixed(2))}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>DEARNESS ALLOWANCE</td>
                    <td>
                      <p>INR {formatter.format(ada.toFixed(2))}</p>
                    </td>
                    <td>
                      <p>INR {formatter.format(mda.toFixed(2))}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>CONVEYANCE</td>
                    <td>
                      <p>INR {formatter.format(acon.toFixed(2))}</p>
                    </td>
                    <td>
                      <p>INR {formatter.format(mcon.toFixed(2))}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>MEDICAL ALLOWANCE</td>
                    <td>
                      <p>INR {formatter.format(ama.toFixed(2))}</p>
                    </td>
                    <td>
                      <p>INR {formatter.format(mma.toFixed(2))}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>SPECIAL ALLOWANCE</td>
                    <td>
                      <p>INR {formatter.format(aspecialAllowance.toFixed(2))}</p>
                    </td>
                    <td>
                      <p>INR {formatter.format(mspecialAllowance.toFixed(2))}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>EPF Employee</td>
                    <td>
                      <p>INR {formatter.format(aepf.toFixed(2))}</p>
                    </td>
                    <td>
                      <p>INR {formatter.format(mepf.toFixed(2))}</p>
                    </td>
                  </tr>
                  <tr className="gross">
                    <td className="gross_title">
                      <b>Gross Salary (1) </b>
                    </td>
                    <td>
                      <p>INR {formatter.format(ast.toFixed(2))}</p>
                    </td>
                    <td>
                      <p>INR {formatter.format(mst.toFixed(2))}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>EPF Employer</td>
                    <td>
                      <p>INR {formatter.format(aepf.toFixed(2))}</p>
                    </td>
                    <td>
                      <p>INR {formatter.format(mepf.toFixed(2))}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>Gratuity</td>
                    <td>
                      <p>INR {formatter.format(gratuity.toFixed(2))}</p>
                    </td>
                  </tr>
                  {payType === 'variable' && (
                    <tr>
                      <td>Variable Pay</td>
                      <td>
                        <p>INR {formatter.format(vp)}</p>
                      </td>
                    </tr>
                  )}
                  {payType === 'deferred' && (
                    <tr>
                      <td>Deferred Pay</td>
                      <td>
                        <p>INR {formatter.format(dp)}</p>
                      </td>
                    </tr>
                  )}
                  <tr className="gross">
                    <td className="gross_title">
                      <b>Gross Salary (2) </b>
                    </td>
                    <td>
                      <p>INR {formatter.format(asubto.toFixed(2))}</p>
                    </td>
                  </tr>
                  <tr className="gross">
                    <td className="gross_title">
                      <b>CTC (1)+(2)</b>
                    </td>
                    <td>
                      <p>
                        <b>INR {formatter.format(ags.toFixed(2))}</b>
                      </p>
                    </td>
                  </tr>
                </tbody>
              </Table>
              <button className="cal-button" onClick={savectcBreakup}>
                <b>Save</b>
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CTCBreakupCalculator;